import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../lib/auth';

export default function RequireAuth({ redirectTo = '/' }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{
          from: location,
          authMessage: 'برای دسترسی به این بخش، ابتدا ورود یا ثبت‌نام کنید.',
        }}
      />
    );
  }

  return <Outlet />;
}

